import querystring from 'querystring';

import { EXTENSION_ORIGINS } from '../constants';
import localStorage from '../utils/localStorage';

window.querystring = querystring;

const NEXT_KEY = '__fpnext';
const PREV_NEXT_KEY = '__fppnext';

const LIVE_ORIGINS_EVENT = 'gfp:extension-origins-updated';

// EXTENSION_ORIGINS above is a static, Chrome/Edge-only list (can't
// include Firefox's random per-profile moz-extension:// uuid). This holds
// whatever origin(s) the current session's live Postmate handshake
// actually confirmed - populated on every browser (it's just redundant
// with EXTENSION_ORIGINS on Chrome/Edge, since those origins are already
// known statically there), but only meaningfully adds new origins on
// Firefox. See LoginListener in login.ts, which is the only caller of
// setLiveExtensionOrigins.
let _liveExtensionOrigins = [];

/**
 * Set the active origins for the extension
 * @param {string[]} origins
 */
export const setLiveExtensionOrigins = (origins) => {
  _liveExtensionOrigins = origins;
  window.dispatchEvent(new Event(LIVE_ORIGINS_EVENT));
};

/**
 * @param {() => void} onUpdate
 * @returns {() => void} unsubscribe
 */
export const subscribeLiveExtensionOrigins = (onUpdate) => {
  window.addEventListener(LIVE_ORIGINS_EVENT, onUpdate);
  return () => window.removeEventListener(LIVE_ORIGINS_EVENT, onUpdate);
};

// Get
export const getNext = (checkBackup) => {
  let val = localStorage.getItem(NEXT_KEY);
  if (_validateUrl(val)) {
    return val;
  }
  if (checkBackup === true) {
    const prevVal = localStorage.getItem(PREV_NEXT_KEY);
    if (_validateUrl(prevVal)) {
      return prevVal;
    }
  }
  return null;
};

// Set
export const setNext = (next) => localStorage.setItem(NEXT_KEY, next);

// Clear
export const clearNext = () => {
  const next = getNext();
  if (next) {
    localStorage.setItem(PREV_NEXT_KEY, next);
  }
  localStorage.removeItem(NEXT_KEY);
};

/**
 * Pass in a list of valid origins and remove any stored values
 * that do not match them.
 * @param {string[]} origins
 */
export const clearInvalidOrigins = (origins) => {
  const keys = [NEXT_KEY, PREV_NEXT_KEY];

  keys.forEach((key) => {
    const val = localStorage.getItem(key);
    if (val && !origins.some((origin) => val.startsWith(origin))) {
      localStorage.removeItem(key);
    }
  });
};

const _validateUrl = (url) =>
  url &&
  EXTENSION_ORIGINS.concat(_liveExtensionOrigins).some(
    (origin) => url.startsWith(`${origin}/`) || url === origin,
  );

// Check URL: auto-saves state and updates URL

export const checkUrl = () => {
  const qs = querystring.parse(window.location.search.substring(1));
  const { next, p } = qs;

  if (next) {
    delete qs.next;
    setNext(next);
  }

  // // use to allow URL parameter to enable premium
  // // now require the extension to do it instead...
  // if (p) {
  //   delete qs.p;
  //   enablePremium();
  // }

  if (next || p) {
    const newQs = querystring.stringify(qs);
    const newUrl = `${window.location.pathname}${newQs ? '?' + newQs : ''}${
      window.location.hash
    }`;
    if (window.history && window.history.replaceState) {
      history.replaceState(null, null, newUrl);
    }
  }
};
